import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostTable() {
  const rows = [{
    sin: '3 horas de planeamiento × 40 semanas',
    costo: '120 horas de tu vida por año'
  }, {
    sin: 'Mensajes de padres sin sistema de respuesta',
    costo: 'Domingos arruinados y desgaste emocional acumulado'
  }, {
    sin: 'Grupos sin protocolo de conducta',
    costo: 'Energía gastada en control en lugar de en enseñanza'
  }, {
    sin: 'Cuatro comités sin documentación',
    costo: 'Riesgo profesional y culpa permanente'
  }, {
    sin: 'Sin tracker de burnout',
    costo: 'Llegás al colapso sin haberlo visto venir'
  }, {
    sin: 'Domingo buscando en internet',
    costo: 'El mismo ciclo, el próximo año y el siguiente'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="text-center mb-10" data-id="element-69">
          <Scale className="w-12 h-12 text-stone-400 mx-auto mb-4" data-id="element-70" />
          <h2 className="text-3xl font-black text-stone-900" data-id="element-71">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="md:hidden text-center text-sm text-stone-500 mb-4 flex items-center justify-center gap-2" data-id="element-72">
          ← Scroll para ver tabla completa →
        </div>

        <div className="overflow-x-auto mb-12" data-id="element-73">
          <table className="w-full min-w-[600px] border-collapse rounded-xl overflow-hidden shadow-sm border border-stone-200" data-id="element-74">
            <thead data-id="element-75">
              <tr data-id="element-76">
                <th className="p-4 text-left font-bold text-stone-600 bg-stone-100 w-1/2" data-id="element-77">
                  Sin MegaPack
                </th>
                <th className="p-4 text-left font-bold text-red-700 bg-red-50 w-1/2" data-id="element-78">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-79">
              {rows.map((row, i) => <tr key={i} className="border-t border-stone-200" data-id="element-80">
                  <td className="p-4 text-stone-600 bg-white" data-id="element-81">{row.sin}</td>
                  <td className="p-4 text-red-900 font-medium bg-red-50/30" data-id="element-82">
                    {row.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-83">
          <p className="text-2xl font-bold text-stone-800 mb-2" data-id="element-84">
            El próximo domingo puede ser diferente.
          </p>
          <p className="text-3xl font-black text-brand-700" data-id="element-85">
            "El próximo domingo puede ser tuyo." 🇨🇷
          </p>
        </motion.div>
      </div>
    </section>;
}